import { getCurrentInstance } from "vue";

export default () => getCurrentInstance().proxy.$i18n;
